import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

const eContractSpecialConditionSerializeMap: SerializeMap<EContractSpecialCondition> =
  {
    agreementId: "agreement_id",
    category: "category",
    created: "created",
    description: "description",
    id: "id",
  };

export const serializeEContractSpecialCondition = buildSerializer(
  eContractSpecialConditionSerializeMap,
  "eContractSpecialCondition",
);

export const deserializeEContractSpecialCondition = buildDeserializer(
  eContractSpecialConditionSerializeMap,
  "eContractSpecialCondition",
);
